/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, ReportFaultRequest } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    ReportFaultRequestFromJSON,
    ReportFaultRequestToJSON,
} from "../models/index";

export interface ReportFaultOperationRequest {
    body?: ReportFaultRequest;
}

/**
 *
 */
export class NotificationsHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Create a new report fault.
     */
    async reportFaultRaw(
        requestParameters: ReportFaultOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/notifications/report-fault`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: ReportFaultRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create a new report fault.
     */
    async reportFault(
        requestParameters: ReportFaultOperationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.reportFaultRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
